/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, ScrollView } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';
import { CONTENT_MAX_WIDTH_AUTH } from '../../shared/layout/breakpoints';
import { useClosedBusinessScreen } from './useClosedBusinessScreen';

const CONTENT_MAX_AUTH = CONTENT_MAX_WIDTH_AUTH;

/**
 * Pantalla para dueños cuyo negocio está cerrado (closed_at != null).
 * Dos acciones: reabrir, cerrar sesión.
 */
export const ClosedBusinessScreen = () => {
  const vm = useClosedBusinessScreen();

  return (
    <View style={styles.root}>
      <ScrollView contentContainerStyle={styles.scrollContent} alwaysBounceVertical={false}>
        <View style={styles.card}>
          <View style={styles.iconWrap}>
            <Ionicons name="storefront-outline" size={48} color={ticketColors.ink3} />
          </View>
          <Text style={styles.title}>Tu negocio está cerrado</Text>
          <Text style={styles.subtitle}>
            Cerraste tu negocio en Vuelto. La tienda online ya no lo muestra y el equipo no tiene acceso.
            Tus pedidos, reclamos e historial se conservan. Podés reabrir cuando quieras.
          </Text>

          <View style={styles.actions}>
            <TouchableOpacity
              style={[styles.btnPrimary, vm.reopening && styles.btnDisabled]}
              onPress={() => void vm.handleReopen()}
              disabled={vm.reopening}
              accessibilityRole="button"
              accessibilityLabel="Reabrir negocio"
            >
              {vm.reopening ? (
                <ActivityIndicator color="#FFFFFF" />
              ) : (
                <Text style={styles.btnPrimaryText}>Reabrir mi negocio</Text>
              )}
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.btnSecondary}
              onPress={() => void vm.handleLogout()}
              disabled={vm.reopening}
              accessibilityRole="button"
              accessibilityLabel="Cerrar sesión"
            >
              <Text style={styles.btnSecondaryText}>Cerrar sesión</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    alignItems: 'center',
    justifyContent: 'center',
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.lg,
  },
  card: {
    width: '100%',
    maxWidth: CONTENT_MAX_AUTH,
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    padding: spacing.xl,
    alignItems: 'center',
    gap: spacing.md,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.ruleSoft,
  },
  iconWrap: {
    marginBottom: spacing.xs,
  },
  title: {
    fontSize: 22,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 15,
    lineHeight: 22,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
    textAlign: 'center',
  },
  actions: {
    width: '100%',
    gap: spacing.sm,
    marginTop: spacing.md,
  },
  btnPrimary: {
    backgroundColor: ticketColors.gold,
    paddingVertical: spacing.md,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
  },
  btnPrimaryText: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: 16,
    fontFamily: ticketFonts.sans,
  },
  btnSecondary: {
    paddingVertical: spacing.md,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  btnSecondaryText: {
    color: ticketColors.ink2,
    fontWeight: '600',
    fontSize: 15,
    fontFamily: ticketFonts.sans,
  },
  btnDisabled: {
    opacity: 0.6,
  },
});
